import styled, { css } from 'styled-components';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { ContainerProps } from './types';

export const Container = styled(Flex)
    .withConfig({ displayName: 'Container' })
    .attrs<ContainerProps>((props) => ({
        position: 'relative',
        width: { xs: '100%', sm: '400px' },
        height: '48px',
        backgroundColor: 'var(--control-secondary-background)',
        borderRadius: '25px',
        overflow: 'hidden',
        display: 'flex',
        textTransform: 'uppercase',
        cursor: props.disabled ? 'not-allowed' : 'pointer',
        pointerEvents: props.disabled ? 'none' : 'auto',
        ...props,
    }))`
    align-items: center;
    justify-content: center;

    &:hover {
        background-color: var(--control-secondary-background-hover);
    }

    ${(props) =>
        props.disabled &&
        css`
            &:hover {
                background-color: var(--control-secondary-background);
            }
        `};
`;

export const ProgressFill = styled(Box).withConfig({ displayName: 'ProgressFill' }).attrs({
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    backgroundColor: 'var(--color-primary)',
    transition: 'width 0.3s ease',
    zIndex: 1,
})`
    &:hover {
        background-color: var(--control-primary-background-hover);
    }
`;

export const TextOverlay = styled(Box).withConfig({ displayName: 'TextOverlay' }).attrs({
    position: 'relative',
    display: 'flex',
    zIndex: 2,
    width: '100%',
    height: '100%',
})`
    align-items: center;
    justify-content: center;
`;

export const WhiteText = styled(Typography)
    .withConfig({ displayName: 'WhiteText' })
    .attrs((props) => ({
        position: 'absolute',
        transition: 'clip-path 0.3s ease',
        textAlign: 'center',
        width: '100%',
        ...props,
    }))`
    color: var(--color-invert);
    white-space: nowrap;
`;

export const BlackText = styled(Typography)
    .withConfig({ displayName: 'BlackText' })
    .attrs((props) => ({
        position: 'absolute',
        width: '100%',
        ...props,
    }))`
    white-space: nowrap;
    transition: clip-path 0.3s ease;
    color: var(--color-primary);
    text-align: center;
`;
